import { render, staticRenderFns } from "./HeroBannerAlpha.vue?vue&type=template&id=2124cb69&scoped=true"
import script from "./HeroBannerAlpha.vue?vue&type=script&lang=js"
export * from "./HeroBannerAlpha.vue?vue&type=script&lang=js"
import style0 from "./HeroBannerAlpha.vue?vue&type=style&index=0&id=2124cb69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2124cb69",
  null
  
)

export default component.exports